// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ThIJi","label":"styles_label__1ZzSg"};